import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Cartao } from '../../../../models/empresa/cartao';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LoadingService } from '../../../../util/loader.service';
import { ConfiguracaoCartaoService } from '../configuracao-cartao.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
const swal = require('sweetalert');


@Component({
  selector: 'app-form-configuracao-cartao',
  templateUrl: './form-configuracao-cartao.component.html',
  styleUrls: ['./form-configuracao-cartao.component.scss']
})
export class FormConfiguracaoCartaoComponent implements OnInit {

  cartao: Cartao;
  valForm: FormGroup;
  public onClose: Subject<any>;
  public codigo: number;
  public record: Cartao;
  pontuacao: number = 0;
  quantidadeDePontos: number = 10;
  possuiValidade: boolean = false;
  dataFimValidade: string = "";
  descricaoCartao: string = "";
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  now = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY'
  };
  pontos = [{ value: 4, descricao: "4 pontos" }, { value: 6, descricao: "6 pontos" }, { value: 8, descricao: "8 pontos" }, { value: 10, descricao: "10 pontos" }, { value: 15, descricao: "15 pontos" }];
  validade = [{ value: true, descricao: "Sim" }, { value: false, descricao: "Não" }]
  constructor(fb: FormBuilder, public loader: LoadingService, private service: ConfiguracaoCartaoService, private route: ActivatedRoute, private _localeService: BsLocaleService) {
    this._localeService.use('pt');
    this.cartao = new Cartao();
    this.now.setMonth(this.now.getMonth() + 1);

    this.cartao.data_fim_validade = moment(new Date(this.now)).format("DD/MM/YYYY");
    this.cartao.quantidade_de_pontos = 10;
    this.cartao.descricao = 'Após 10 compras realizadas você converte 10% do valor total dos produtos adquiridos em outras mercadorias de sua escolha.';

    this.valForm = fb.group({
      'cartaoDescricao': [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
      'cartaoNome': [null, Validators.required],
      'cartaoQuantidadeDePontos': [null, Validators.required],
      'cartaoPossuiValidade': [null, Validators.required],
      'cartaoDataFimValidade': [null, Validators.required],
      'padrao': [false, null],
      'valor_ponto': [false, null],
    });
  }


  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      if (this.cartao.id_cartao != null) {
        this.loader.show('body');
        this.cartao.id = this.record.id_cartao;

        var newCartao = new Cartao();
        newCartao.id = this.cartao.id_cartao;
        newCartao.nome = this.cartao.nome;
        newCartao.descricao = this.cartao.descricao;
        newCartao.possui_validade = this.cartao.possui_validade;
        newCartao.quantidade_de_pontos = this.cartao.quantidade_de_pontos;
        newCartao.data_fim_validade = this.parseBool(this.cartao.possui_validade) ?
          (moment(this.cartao.data_fim_validade).isValid() ? this.cartao.data_fim_validade : this.formatDateBr(this.cartao.data_fim_validade)) : "";

        this.service.atualizarCartao(newCartao)
          .subscribe(result => {
            this.loader.hide('body');
            if (result.id_cartao != null) {
              swal('Sucesso', 'Ação realizada com sucesso!', 'success');

            }
          });
      } else {
        this.loader.show('body');
        this.cartao.data_fim_validade = this.parseBool(this.cartao.possui_validade) ?
          (moment(this.cartao.data_fim_validade).isValid() ? this.cartao.data_fim_validade : this.formatDateBr(this.cartao.data_fim_validade)) : "";
        this.service.cadastrarCartao(this.cartao)
          .subscribe(result => {
            this.loader.hide('body');
            if (result.id_cartao != null) {
              swal('Sucesso', 'Ação realizada com sucesso!', 'success');

            }
          });
      }
    }
  }
  parseBool(b) {
    return !(/^(false|0)$/i).test(b) && !!b;
  }
  onSelectCard(event) {
    this.quantidadeDePontos = Number(this.cartao.quantidade_de_pontos);
    this.possuiValidade = this.parseBool(this.cartao.possui_validade);
  }
  onSelectPossuiValidade(event) {
    this.possuiValidade = this.parseBool(this.cartao.possui_validade);
    this.quantidadeDePontos = Number(this.cartao.quantidade_de_pontos);
    if (this.possuiValidade) {
      this.valForm.controls['cartaoDataFimValidade'].setValidators([Validators.required]);
      this.valForm.controls["cartaoDataFimValidade"].updateValueAndValidity();
      this.cartao.data_fim_validade = moment(new Date(this.now)).format("DD/MM/YYYY");
    } else {
      this.valForm.controls["cartaoDataFimValidade"].clearValidators();
      this.valForm.controls["cartaoDataFimValidade"].updateValueAndValidity();
    }
  }
  changeDescricao($event) {
    this.descricaoCartao = this.cartao.descricao;
  }
  dataValidadeChange($event) {
    var formatedDate = moment(new Date(this.cartao.data_fim_validade)).format("DD/MM/YYYY");

    this.dataFimValidade = formatedDate == "Invalid date" ? this.cartao.data_fim_validade : formatedDate;
  }


  ngOnInit() {

    if (this.record !== undefined) {

      this.cartao = this.record;

      var dataFormated = moment(new Date(this.record.data_fim_validade)).format("DD/MM/YYYY");
      this.cartao.data_fim_validade = dataFormated;
      this.dataFimValidade = dataFormated;
      this.onSelectPossuiValidade(null);
      this.valForm.get('cartaoQuantidadeDePontos').disable();
    } else {
      this.valForm.controls["cartaoDataFimValidade"].clearValidators();
      this.valForm.controls["cartaoDataFimValidade"].updateValueAndValidity();
    }

  }
  formatDateBr(dateString): string {
    var dataSplit = dateString.split('/');
    var dateConverted;

    if (dataSplit[2].split(" ").length > 1) {

      var hora = dataSplit[2].split(" ")[1].split(':');
      dataSplit[2] = dataSplit[2].split(" ")[0];
      dateConverted = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0], hora[0], hora[1]);

    } else {
      dateConverted = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
    }

    return dateConverted;
  }

}
